{
  "order_button": "Komand ci WhatsApp",
  "order_button_short": "WhatsApp",
  "support_button": "Ndimbal WhatsApp",
  "confirmation": {
    "title": "Dëggal ci WhatsApp",
    "subtitle": "Yonneel sa komand ci WhatsApp ngir dëggal bu gaaw",
    "send": "Yonnee ci WhatsApp",
    "already_confirmed": "Dëggal naa ko ba pare",
    "preview_title": "Xoolal bataaxal bi"
  },
  "messages": {
    "order_greeting": "Assalaamu aleykum, damay bëgg komand :",
    "order_total": "Tollu",
    "order_delivery": "Indil",
    "order_payment": "Fey",
    "order_thanks": "Jërëjëf !",
    "support_greeting": "Assalaamu aleykum, damay soxla ndimbal ci",
    "tracking_request": "Assalaamu aleykum, damay bëgg xam fumu sama komand tollu"
  },
  "new_order_title": "Komand bu bees ci Djayma"
}
